<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" :rules="rules" ref="form" label-width="140px">
        <el-form-item label="节点名称" prop="nodeName">
          <el-input clearable v-model="formData.nodeName" placeholder="请输入节点名称"></el-input>
        </el-form-item>
        <el-form-item label="节点审批角色" prop="nodeRole">
          <el-select v-model="formData.nodeRole" filterable placeholder="请选择节点审批角色">
            <el-option :value="item.roleId" :label="item.roleName" v-for="(item, index) of roleList"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="驳回节点" v-if="showUpNode" prop="upNode">
          <el-select v-model="formData.upNode" filterable clearable placeholder="请选择驳回节点">
            <el-option :value="item.nodeId" :label="item.nodeName" v-for="(item, index) of nodelist"
              :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

  </div>
</template>

<script>

export default {

  name: 'FlowManageAdd',
  data () {
    return {
      formData: {
        nodeId: '',
        nodeKey: '',
        nodeName: '',
        nodeRole: '',
        nextNode: '',
        upNode: ''
      },
      rules: {
        nodeName: [{ required: true, message: '请输入节点名称', trigger: ['change', 'blur'] }],
        nodeRole: [{ required: true, message: '请选择节点审批角色', trigger: 'change' }]
      },
      roleList: [],
      nodelist: []
    }
  },
  computed: {
    nodeId () {
      return this.$route.query.nodeId
    },
    nodeKey() {
      return this.$route.query.nodeKey
    },
    showUpNode() {
      if (this.nodelist && this.nodelist.length) {
        return this.nodelist[0].nodeId !== this.nodeId
      }
      return false
    }
  },
  created () {
    this.loadType()
    if (this.nodeId) {
      this.loadDetails()
    }
  },
  methods: {
    loadType () {
      this.$axios
        .get(this.$apis.flowManage.selectYgNodeByList, {
          params: {
            nodeKey: this.nodeKey
          }
        })
        .then(res => {
          this.nodelist = res.list || []
        })
      // 角色
      this.$axios.get(this.$apis.system.selectSysRoleByList).then(res => {
        this.roleList = res || []
      })
    },

    loadDetails () {
      this.loading = true
      this.$axios
        .get(this.$apis.flowManage.selectYgNodeByNodeId, {
          params: { nodeId: this.nodeId }
        })
        .then(res => {
          this.formData = res || {}
        })
        .finally(() => {
          this.loading = false
        })
    },
    submit () {
      this.$refs.form.validate().then(() => {
        const url = this.$apis.flowManage.updateYgNode
        this.$axios.post(url, this.formData).then(res => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 400px;
}
</style>
